<template>
  <div>
    <el-upload
      ref="upload"
      :class="[
        'l-upload',
        { 'l-upload-onlyone': limit == 1 && isImg && !drag },
        { 'no-upload-btn': limit == 1 && isImg && value },
        disabled ? 'readonly' : '',
      ]"
      action=""
      :http-request="myUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :multiple="multiple"
      :limit="limit"
      :accept="aaccept2"
      :on-exceed="handleExceed"
      :on-success="handlesuccess"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :data="param"
      :list-type="listType"
      :show-file-list="myShowFileList"
      :drag="drag"
      :disabled="disabled"
    >
      <div v-if="isTip" slot="tip" class="el-upload__tip">{{ tipMsg }}</div>
      <slot>
        <template v-if="!disabled">
          <el-button
            v-if="!isImg && !drag"
            size="mini"
            :type="btnType"
            icon="el-icon-upload"
            >{{ $t(btnText) }}</el-button
          >
          <template v-else-if="drag">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </template>
          <i v-else class="el-icon-plus"></i>
        </template>
      </slot>
    </el-upload>

    <l-dialog
      v-if="!isImg"
      title="文件预览"
      :visible.sync="previewVisible"
      width="1000px"
      :height="800"
    >
      <iframe
        v-if="previewUrl != ''"
        :src="previewUrl"
        class="l-iframe"
        ref="iframe"
        frameborder="0"
      ></iframe>
      <template #btns>
        <el-button
          size="mini"
          icon="el-icon-down"
          type="primary"
          @click="
            downFile(
              `${apiUrl}system/annexesfile/${previewFileId}?token=${token}`
            )
          "
          >下载</el-button
        >
      </template>
    </l-dialog>

    <el-dialog
      :append-to-body="true"
      v-if="isImg"
      :visible.sync="previewVisible"
    >
      <img width="100%" :src="previewUrl" alt="" />
    </el-dialog>

    <l-dialog
      :title="$t(uploadTitle)"
      :width="400"
      :modal="false"
      :hasBtns="false"
      :hasHeight="false"
      :hasMinBtn="true"
      placement="bottom-right"
      :visible.sync="loadVisible"
    >
      <div class="learun-file-list">
        <div
          v-for="item in uploadingFiles"
          :key="item.uid"
          class="learun-list-item"
        >
          <div class="learun-list-item-wraper">
            <div class="learun-list-item-icon">
              <i
                :class="item.icon || 'learun-icon-ufo'"
                :style="{ color: item.color }"
              ></i>
            </div>
            <div class="learun-list-item-content">
              <div class="learun-list-item-title">
                {{ item._name || item.name }}
              </div>
            </div>
            <div
              class="learun-list-item-des"
              v-if="item.isUploading || item.isSuccess"
            >
              {{ $countFileSize(item.uploadSize) }}/{{
                $countFileSize(item.size)
              }}
            </div>
            <div :title="item.error" class="learun-list-item-des" v-else>
              {{ item.error }}
            </div>
            <div class="learun-list-item-icon">
              <div class="icons">
                <el-progress
                  v-if="item.isUploading"
                  :width="24"
                  :stroke-width="4"
                  type="circle"
                  :show-text="false"
                  :percentage="item.percent"
                >
                </el-progress>
                <i
                  v-else-if="item.isSuccess"
                  class="learun-icon-circle-correct-base learun-success"
                ></i>
                <i v-else class="learun-icon-circle-hint-base learun-error"></i>
              </div>
              <div class="icons-hover">
                <el-tooltip
                  popper-class="learun-tooltip-top"
                  v-if="item.isUploading"
                  effect="dark"
                  content="取消上传"
                  placement="top"
                >
                  <i
                    @click="handleCancelUpload(item)"
                    class="learun-icon-circle-error-base learun-info"
                  ></i>
                </el-tooltip>
                <i
                  v-else-if="item.isSuccess"
                  class="learun-icon-circle-correct-base learun-success"
                ></i>
                <el-tooltip
                  popper-class="learun-tooltip-top"
                  v-else
                  effect="dark"
                  content="重新上传"
                  placement="top"
                >
                  <i
                    @click="handleUploadAgain(item)"
                    class="learun-icon-refresh learun-info"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </l-dialog>
  </div>
</template>

<script>
export default {
  name: "l-upload",
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxSize: String,
    sizeType: String,
    accept: String,

    isTip: Boolean,
    showFileList: {
      type: [Boolean, String],
      default: true,
    },
    listType: String,

    drag: {
      type: Boolean,
      default: false,
    },

    btnText: {
      type: String,
      default: "点击上传",
    },
    btnType: {
      type: String,
      default: "primary",
    },

    isNotUpLoad: {
      type: Boolean,
      default: false,
    },
    isNotDelete: {
      type: Boolean,
      default: false,
    },

    upload: Function,
    uploadCallback: Function,
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (this.$validatenull(val)) {
          this.folderId = this.$uuid();
          this.fileList = [];
        } else {
          // 加载列表页
          if (
            (val != oldVal && !this.$validatenull(oldVal)) ||
            val != this.folderId
          ) {
            this.handleLoadFileList(val);
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      folderId: "",
      fileList: [],
      uploadFiles: [],

      previewVisible: false,
      previewFileId: "",
      previewUrl: "",

      loadVisible: false,
      uploadingFiles: [],
    };
  },
  created() {
    this.folderId = this.$uuid();
  },
  mounted() {},
  computed: {
    param() {
      return {
        folderId: this.value || this.folderId,
        maxSize: this.maxSize,
        sizeType: this.sizeType,
      };
    },
    tipMsg() {
      return `只能上传不超过${this.maxSize || ""}${this.sizeType || ""}的${
        this.accept || ""
      }文件`;
    },
    isImg() {
      return this.listType == "picture-card";
    },
    aaccept2() {
      if (this.isImg) {
        return "image/*";
      } else {
        return this.accept;
      }
    },
    uploadTitle() {
      if (this.uploadingFiles.filter((t) => t.isUploading).length > 0) {
        const successNum = this.uploadingFiles.filter(
          (t) => t.isSuccess
        ).length;
        return `上传中...${successNum}/${this.uploadingFiles.length}`;
      } else {
        const cancelNum = this.uploadingFiles.filter((t) => t.isCancel).length;
        const failNum =
          this.uploadingFiles.filter((t) => t.isSuccess == false).length -
          cancelNum;

        let title = "";
        if (failNum > 0) {
          title += `${failNum}个上传失败`;
        }
        if (cancelNum > 0) {
          if (title != "") {
            title += ",";
          }
          title += `${cancelNum}个上传取消`;
        }

        if (title == "") {
          return "上传完成";
        }

        return title;
      }
    },
    myShowFileList() {
      if (this.showFileList == true) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      // 从这里可以看出是找到对应的组件对象
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    async handleLoadFileList(val) {
      if (this.lr_getFileList) {
        let data = await this.lr_getFileList(val);
        if (val == this.value) {
          this.fileList = data;
        }
        if (data.length == 0) {
          this.$emit("input", "");
        }
      }
    },
    handlesuccess(response) {
      this.uploadFiles.push(response);
      if (!this.value) {
        this.$emit("input", response.folderId);
        setTimeout(() => {
          this.dispatch("ElFormItem", "el.form.blur", ["xxx"]);
        });
      }
      this.$emit("success", response);
    },
    handleRemove(file) {
      if (file.response) {
        if (!this.isNotDelete) {
          this.lr_deleteFile && this.lr_deleteFile(file.response.fileId);
        }
        this.uploadFiles.splice(
          this.uploadFiles.findIndex((t) => t.fileId == file.response.fileId),
          1
        );
      } else if (file.id) {
        if (!this.isNotDelete) {
          this.lr_deleteFile && this.lr_deleteFile(file.id);
        }
        this.fileList.splice(
          this.fileList.findIndex((t) => t.id == file.id),
          1
        );
      }

      if (this.uploadFiles.length == 0 && this.fileList.length == 0) {
        this.$emit("input", "");
      }
    },
    handlePreview(file) {
      const fileExt = file.name.split(".")[file.name.split(".").length - 1];
      const fileId = file.id || file.response.fileId;
      switch (fileExt) {
        case "xls":
        case "xlsx":
        case "docx":
        case "txt":
        case "csv":
        case "html":
        case "pdf":
          if (this.$validatenull(this.apiUrl)) {
            return;
          }
          this.previewUrl = `${this.apiUrl}system/annexesfile/preview/${fileId}?token=${this.token}`;
          this.previewFileId = fileId;
          this.previewVisible = true;
          break;
        case "jpg":
        case "gif":
        case "png":
        case "bmp":
        case "jpeg":
        case "svg":
          if (this.isImg) {
            if (file.url) {
              this.previewUrl = file.url;
            } else {
              if (this.$validatenull(this.apiUrl)) {
                return;
              }
              this.previewUrl = `${this.apiUrl}system/annexesfile/${fileId}?token=${this.token}`;
            }
            this.previewVisible = true;
          } else {
            if (this.$validatenull(this.apiUrl)) {
              return;
            }
            this.previewUrl = `${this.apiUrl}system/annexesfile/preview/${fileId}?token=${this.token}`;
            this.previewFileId = fileId;
            this.previewVisible = true;
            break;
          }

          break;
        default:
          // 不支持预览，就直接下载
          this.$message.warning(`当前文件格式不支持预览${fileExt}`);
          if (this.$validatenull(this.apiUrl)) {
            return;
          }
          this.downFile(
            `${this.apiUrl}system/annexesfile/${fileId}?token=${this.token}`
          );
          break;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file) {
      if (!this.compareSize(file.size)) {
        return true;
      }
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    downFile(url) {
      this.$downFile(`${url}`);
    },
    handleBeforeUpload(file) {
      if (!this.compareSize(file.size)) {
        this.$message.warning("上传文件超出大小了");
        return false;
      }
    },
    compareSize(fileSize) {
      if (this.maxSize && this.sizeType) {
        let size = fileSize;
        switch (this.sizeType) {
          case "GB":
            size = 1024 * 1024 * 1024 * Number(this.maxSize);
            break;
          case "MB":
            size = 1024 * 1024 * Number(this.maxSize);
            break;
          case "KB":
            size = 1024 * Number(this.maxSize);
            break;
          case "B":
          default:
            size = Number(this.maxSize);
            break;
        }
        if (size < fileSize) {
          return false;
        }
      }
      return true;
    },
    myUpload(option) {
      if (!this.isNotUpLoad) {
        if (this.upload) {
          this.upload(option);
          return;
        } else if (this.showFileList == "bottom") {
          this.upLoadFiles([option.file]);
        } else if (this.lr_chunkedUpload) {
          this.lr_chunkedUpload(option, this.uploadCallback);
          return;
        }
      }
      const { file } = option;
      option.onSuccess({
        name: file.name,
      });
    },

    closeUpLoadFileForm() {
      this.loadVisible = false;
    },
    upLoadFiles(files) {
      if (!this.loadVisible) {
        this.uploadingFiles = this.uploadingFiles.filter((t) => t.isUploading);
      }
      files = files || [];
      if (files.length > 0) {
        files.forEach((file) => {
          const option = {
            data: this.param,
            filename: file.name,
            file,
            onProgress: this.onUpLoadProgress,
            onSuccess: this.onUpLoadSuccess,
            onError: this.onError,
            onStart: this.onStart,
          };
          file.isUploading = true;
          file.uploadSize = 0;
          const fileIcon = this.lr_getFileIcon(file.name, file.type);
          file.icon = fileIcon.icon;
          file.color = fileIcon.color;
          this.lr_chunkedUpload(option, this.uploadCallback);
        });

        this.uploadingFiles.push(...files);
        this.loadVisible = true;
      }
    },
    onStart({ uid, xhr, chunks, id }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        file.xhrs = file.xhrs || [];
        file.xhrs.push(xhr);
        file.chunks = chunks;
        file.id = id;
      }
    },
    onUpLoadProgress({ uid, fileSize, percent }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        if (file.isCancel) {
          return;
        }
        file.uploadSize = fileSize;
        file.percent = percent;
        if (percent == 100) {
          file.xhrs == null;
        }
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
      }
    },
    onUpLoadSuccess({ uid }) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        file.isSuccess = true;
        file.isUploading = false;
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);

        this.$emit("success", file);
      }
    },
    onError(error, uid) {
      const file = this.uploadingFiles.find((t) => t.uid == uid);
      if (file) {
        if (file.isCancel) {
          return;
        }
        file.isSuccess = false;
        file.isUploading = false;
        file.error = error;
        this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
      }
      console.error(error, "learun 景云2.0平台:文件上传错误！");
    },

    async handleCancelUpload(file) {
      if (file.percent == 100) {
        // 文件分片已经上传完了无法取消
        this.$message({
          type: "warning",
          message: this.$t("已经上传无法取消！"),
        });
      }

      if (file.xhrs) {
        // 取消文件上传，需要清空已经上传的文件分片
        file.xhrs.forEach((xhr) => {
          xhr.abort();
        });
        if (this.lr_removeFileChunks) {
          await this.lr_removeFileChunks(file.id, file.chunks);
        }
      }
      file.isSuccess = false;
      file.isUploading = false;
      file.error = "取消上传";
      file.isCancel = true;
      this.$set(this.uploadingFiles, 0, this.uploadingFiles[0]);
    },
    handleUploadAgain(file) {
      file.isUploading = true;
      file.uploadSize = 0;
      file.error = "";
      file.isCancel = false;

      const option = {
        data: this.param,
        filename: file.name,
        file,
        onProgress: this.onUpLoadProgress,
        onSuccess: this.onUpLoadSuccess,
        onError: this.onError,
        onStart: this.onStart,
      };

      this.lr_chunkedUpload(option, this.uploadCallback);
    },
    /*uploadDialogOpen(){
            this.uploadingFiles = this.uploadingFiles.filter(t=>t.isUploading)
        }*/
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
